export const sanitizeStoredUser = (user = {}) => ({
  id: user.id || user._id || '',
  name: user.name || user.username || '',
  role: user.role || '',
  departmentId: user.departmentId || '',
  departmentName: user.departmentName || '',
  departmentCode: user.departmentCode || '',
});

export const loadUserFromLocalStorage = () => {
  try {
    const user = localStorage.getItem('user');
    return user ? sanitizeStoredUser(JSON.parse(user)) : null;
  } catch (error) {
    localStorage.removeItem('user');
    return null;
  }
};
